module.exports = __webpack_public_path__ + "static/media/4-min.1f8f965b.png";